import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "account",
  "use": "account-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"account\"><circle cx=\"8\" cy=\"4.75\" r=\"2.733\" stroke=\"currentColor\" /><path stroke=\"currentColor\" d=\"M13.546 10.607C13.546 9.305 12.19 9.37 8 9.37c-4.19 0-5.546-.064-5.546 1.238 0 1.303 2.483 3.3 5.546 3.3s5.546-1.997 5.546-3.3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol